{
  "v7.projets.activite.quoi": "de l’activité des projets",
  "v7.projets.activite.titre": "Activité des projets",
  "v7.projets.activite.vide": "Aucune activité récente dans les projets visibles du programme.",
  "v7.projets.annuler": "Annuler",
  "v7.projets.choisi.aucun": "Choisissez un projet de la liste pour voir son détail.",
  "v7.projets.choisi.avancement": "Avancement",
  "v7.projets.choisi.lance": "Lancé",
  "v7.projets.choisi.lancement_inacheve": "Lancement inachevé : il se poursuit dans le projet",
  "v7.projets.choisi.modele": "Modèle",
  "v7.projets.choisi.projet": "Projet",
  "v7.projets.choisi.role": "Votre rôle",
  "v7.projets.choisi.titre": "Projet choisi",
  "v7.projets.choisir": "Choisir",
  "v7.projets.code.CONFIRMATION_IDENTITE_ECHOUEE": "Mot de passe incorrect : identité non confirmée.",
  "v7.projets.code.CONFIRMATION_IDENTITE_REQUISE": "Une confirmation d’identité récente est requise.",
  "v7.projets.code.CONTEXTE_INCOMPLET": "Le contexte du programme est incomplet : rechargez la page.",
  "v7.projets.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis.",
  "v7.projets.code.GARDE_DROIT_ABSENTE": "Ce geste n’est pas encore ouvert par la passerelle.",
  "v7.projets.code.IDEMPOTENCY_KEY_CONFLICT": "Cette demande de création a déjà été envoyée avec d’autres valeurs : rouvrez le dialogue.",
  "v7.projets.code.INVALID_IDEMPOTENCY_KEY": "Clé de demande invalide : rouvrez le dialogue.",
  "v7.projets.code.NOT_FOUND": "Introuvable.",
  "v7.projets.code.PROGRAMME_A_DES_PROJETS": "Ce programme a encore des projets rattachés : détachez-les d’abord.",
  "v7.projets.code.PROGRAMME_MODELE_NON_ADMIS": "Ce modèle de projet n’est pas admis par le modèle du programme.",
  "v7.projets.code.PROGRAMME_NOM_DE_CONFIRMATION_DIFFERENT": "Le nom saisi ne correspond pas au nom du programme.",
  "v7.projets.code.PROGRAMME_PROPOSITION_DEJA_EN_ATTENTE": "Une proposition de rattachement de ce projet attend déjà la décision de son propriétaire.",
  "v7.projets.code.PROGRAMME_TRAITEMENT_ACTIF": "Un traitement du programme est en cours : attendez sa fin.",
  "v7.projets.code.PROGRAM_SETTINGS_CONFLICT": "Les réglages ont été modifiés entre-temps : rechargez-les avant d’enregistrer.",
  "v7.projets.code.PROJECT_ALREADY_ATTACHED": "Ce projet est déjà rattaché à un autre programme : détachez-le d’abord.",
  "v7.projets.code.PROJECT_ATTACHED_ELSEWHERE": "Ce projet est rattaché à un autre programme.",
  "v7.projets.code.PROJECT_OWNER_REQUIRED": "Seul qui gouverne ce projet (son propriétaire) peut le rattacher ou le détacher.",
  "v7.projets.code.PROPOSITION_CADUQUE": "Cette proposition est déjà décidée ou retirée.",
  "v7.projets.code.PROPRIETAIRE_SEUL": "Réservé au propriétaire du programme.",
  "v7.projets.code.REQUIREMENT_HAS_WAIVER_HISTORY": "Une règle du programme porte un historique de dérogation : le programme ne peut être supprimé.",
  "v7.projets.code.RESOURCE_UNAVAILABLE": "Ce programme est introuvable ou ne vous est pas ouvert.",
  "v7.projets.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v7.projets.code.TEMPLATE_VERSION_NOT_PUBLISHED": "La version de ce modèle n’est pas publiée.",
  "v7.projets.code.VALIDATION_ERROR": "Saisie refusée : vérifiez les champs.",
  "v7.projets.code.WORKSPACE_CREATION_CANCELLED": "Cette création a été annulée : rouvrez le dialogue.",
  "v7.projets.configuration.admis": "Modèles de projet admis",
  "v7.projets.configuration.attente": "Le choix s’ouvre une fois les réglages et les modèles admis lus.",
  "v7.projets.configuration.aucun_propose": "Aucun modèle proposé",
  "v7.projets.configuration.choix": "Modèle proposé aux nouveaux projets",
  "v7.projets.configuration.choix_aide": "Choisi parmi les modèles admis par le modèle du programme ; pré-sélectionné à la création d’un projet.",
  "v7.projets.configuration.enregistre": "Modèle proposé enregistré.",
  "v7.projets.configuration.enregistrer": "Enregistrer le modèle proposé",
  "v7.projets.configuration.fige": "Modèle figé à la création du programme.",
  "v7.projets.configuration.modele": "Modèle du programme",
  "v7.projets.configuration.modele_inconnu": "Le modèle du programme n’est pas connu.",
  "v7.projets.configuration.modele_version": "{{id}}, version {{version}}",
  "v7.projets.configuration.propose": "Proposition aux nouveaux projets",
  "v7.projets.configuration.propose_par_defaut": "proposé par défaut",
  "v7.projets.configuration.sans_liste": "Le modèle du programme ne restreint pas les modèles de projet : tout modèle publié de l’organisation est admis.",
  "v7.projets.configuration.service": "Engagement de service",
  "v7.projets.configuration.service_texte": "Le modèle du programme fixe un engagement de service pour le flux continu de ses projets.",
  "v7.projets.configuration.titre": "Réglages du programme — configuration",
  "v7.projets.creer.creer": "Créer le projet",
  "v7.projets.creer.modele": "Modèle du projet",
  "v7.projets.creer.nom": "Nom du projet",
  "v7.projets.creer.plus_tard": "Créer et lancer plus tard",
  "v7.projets.creer.propriete": "Vous en devenez propriétaire ; vous pourrez transférer la propriété à un membre.",
  "v7.projets.creer.titre": "Créer un projet dans le programme",
  "v7.projets.creer.version": "Modèle à sa version publiée {{version}}, figée dans le projet.",
  "v7.projets.creer_un_projet": "Créer un projet",
  "v7.projets.cycle.aucun_projet": "Aucun projet rattaché.",
  "v7.projets.cycle.detachez_d_abord": "Des projets sont rattachés au programme : détachez-les d’abord.",
  "v7.projets.cycle.etat": "État du programme",
  "v7.projets.cycle.gestes": "Propriété et suppression",
  "v7.projets.cycle.projets": "{{n}} projets rattachés (dont {{caches}} non visible).",
  "v7.projets.cycle.projets_one": "{{n}} projet rattaché (dont {{caches}} non visible).",
  "v7.projets.cycle.quoi": "des projets rattachés",
  "v7.projets.cycle.rattaches_en_lecture": "Lecture des projets rattachés : la suppression attend de les compter.",
  "v7.projets.cycle.rattaches_inconnus": "Nombre de projets rattachés illisible : la suppression attend de le connaître.",
  "v7.projets.cycle.statut.active": "Programme actif.",
  "v7.projets.cycle.statut.inactive": "Programme inactif.",
  "v7.projets.cycle.statut.suspended": "Programme suspendu.",
  "v7.projets.cycle.titre": "Réglages du programme — cycle de vie",
  "v7.projets.cycle.transferer": "Transférer la propriété",
  "v7.projets.detacher": "Détacher",
  "v7.projets.detacher.consequence.administration": "Le programme perd l’administration descendante du projet.",
  "v7.projets.detacher.consequence.figes": "Les choix technologiques hérités sont figés en choix propres du projet.",
  "v7.projets.detacher.consequence.regles": "Les règles et technologies du programme cessent de s’appliquer à ce projet.",
  "v7.projets.detacher.effet.administration": "Le programme n’administre plus ce projet.",
  "v7.projets.detacher.effet.derogations": "{{n}} dérogations levées.",
  "v7.projets.detacher.effet.derogations_one": "{{n}} dérogation levée.",
  "v7.projets.detacher.effet.perimees": "{{n}} règles conservées comme périmées (historique de dérogation).",
  "v7.projets.detacher.effet.perimees_one": "{{n}} règle conservée comme périmée (historique de dérogation).",
  "v7.projets.detacher.effet.referentiel": "Choix hérités figés dans la version {{version}} du référentiel du projet.",
  "v7.projets.detacher.effet.regles": "{{n}} règles héritées retirées.",
  "v7.projets.detacher.effet.regles_one": "{{n}} règle héritée retirée.",
  "v7.projets.detacher.succes": "Projet détaché du programme.",
  "v7.projets.detacher.titre": "Détacher « {{projet}} » du programme ?",
  "v7.projets.ecran_ulterieur": "L’écran « {{ecran}} » n’est pas encore ouvert dans cette version.",
  "v7.projets.enregistrer": "Enregistrer",
  "v7.projets.etat.chargement": "Lecture {{quoi}}…",
  "v7.projets.etat.en_cours": "En cours…",
  "v7.projets.etat.erreur": "La lecture {{quoi}} a échoué.",
  "v7.projets.etat.introuvable": "Introuvable ou non ouvert : {{quoi}}.",
  "v7.projets.etat.reessayer": "Réessayer",
  "v7.projets.etat.refus": "Lecture {{quoi}} refusée.",
  "v7.projets.geste.erreur": "Le geste a échoué. Réessayez.",
  "v7.projets.liste.actions": "actions",
  "v7.projets.liste.etat": "état",
  "v7.projets.liste.legende": "Projets rattachés au programme",
  "v7.projets.liste.modele": "modèle",
  "v7.projets.liste.modele_admis": "admis par le programme",
  "v7.projets.liste.modele_non_admis": "non admis par le programme",
  "v7.projets.liste.projet": "projet",
  "v7.projets.liste.quoi": "des projets du programme",
  "v7.projets.liste.sante": "santé",
  "v7.projets.liste.sante_valeur": "{{approbations}} approbations en attente, {{traitements}} traitements",
  "v7.projets.liste.titre": "Projets rattachés",
  "v7.projets.liste.vide": "Aucun projet n’est rattaché à ce programme.",
  "v7.projets.modeles.aucun": "Aucun modèle de projet admis n’est publié dans l’organisation.",
  "v7.projets.modeles.option_proposee": "{{nom}} (proposé par le programme)",
  "v7.projets.modeles.quoi": "des modèles admis par le programme",
  "v7.projets.non_visibles": "{{n}} projets du programme ne vous sont pas visibles : ils sont comptés sans détail.",
  "v7.projets.non_visibles_one": "{{n}} projet du programme ne vous est pas visible : il est compté sans détail.",
  "v7.projets.onglet.configuration": "Configuration",
  "v7.projets.onglet.cycle": "Cycle de vie",
  "v7.projets.onglet.identite": "Identité",
  "v7.projets.onglet.objectif": "Objectif et registre",
  "v7.projets.onglets": "Réglages du programme",
  "v7.projets.ouvrir": "Ouvrir",
  "v7.projets.ouvrir.non_membre": "Vous n’êtes pas membre de ce projet.",
  "v7.projets.propositions.etat.caduque": "caduque",
  "v7.projets.propositions.etat.en_attente": "en attente de son propriétaire",
  "v7.projets.propositions.etat.refusee": "refusée",
  "v7.projets.propositions.motif": "Motif : {{motif}}",
  "v7.projets.propositions.non_visible": "Projet non visible",
  "v7.projets.propositions.quoi": "des propositions de rattachement",
  "v7.projets.propositions.retiree": "Proposition retirée.",
  "v7.projets.propositions.retirer": "Retirer",
  "v7.projets.propositions.retirer_nom": "Retirer la proposition de {{projet}}",
  "v7.projets.propositions.titre": "Propositions de rattachement",
  "v7.projets.propositions.vide": "Aucune proposition de rattachement.",
  "v7.projets.rattacher.aucun": "Aucun autre projet visible de l’organisation à rattacher.",
  "v7.projets.rattacher.aussitot": "Vous êtes propriétaire de ce projet : il sera rattaché aussitôt.",
  "v7.projets.rattacher.choisir": "Choisir un projet",
  "v7.projets.rattacher.deja_ailleurs": "déjà rattaché à un autre programme",
  "v7.projets.rattacher.effet.administration": "Le programme gagne l’administration descendante du projet.",
  "v7.projets.rattacher.effet.droits": "Les profils du programme s’appliquent au projet ; un profil de projet plus restreint l’emporte.",
  "v7.projets.rattacher.effet.heritage": "L’héritage par catégorie est conservé.",
  "v7.projets.rattacher.effet.regles": "Les règles et technologies du programme s’appliquent au projet.",
  "v7.projets.rattacher.non_admis": "modèle non admis par le programme",
  "v7.projets.rattacher.projet": "Projet à rattacher",
  "v7.projets.rattacher.proposer": "Proposer le rattachement",
  "v7.projets.rattacher.proposition": "Ce projet a un autre propriétaire : une proposition lui sera envoyée, en attente de son accord.",
  "v7.projets.rattacher.quoi": "des projets de l’organisation",
  "v7.projets.rattacher.rattacher": "Rattacher",
  "v7.projets.rattacher.titre": "Rattacher un projet au programme",
  "v7.projets.rattacher_un_projet": "Rattacher un projet",
  "v7.projets.reglages.description": "Description",
  "v7.projets.reglages.description_aide": "Facultative.",
  "v7.projets.reglages.enregistres": "Réglages enregistrés.",
  "v7.projets.reglages.nom": "Nom du programme",
  "v7.projets.reglages.quoi": "des réglages du programme",
  "v7.projets.reglages.recharger": "Recharger",
  "v7.projets.reglages.titre": "Réglages du programme — identité",
  "v7.projets.reglages.titre_section": "Identité",
  "v7.projets.role.aucun": "non membre",
  "v7.projets.role.contributor": "Contributeur",
  "v7.projets.role.owner": "Propriétaire",
  "v7.projets.role.viewer": "Lecteur",
  "v7.projets.sans_programme": "Choisissez d’abord un programme.",
  "v7.projets.statut.active": "actif",
  "v7.projets.statut.archived": "archivé",
  "v7.projets.supprimer.effet.journal": "Les initiatives, le registre, les choix et l’historique sont conservés au journal de l’organisation.",
  "v7.projets.supprimer.effet.projets": "Le programme ne doit plus avoir aucun projet rattaché.",
  "v7.projets.supprimer.effet.traitement": "Aucun traitement du programme ne doit être en cours.",
  "v7.projets.supprimer.nom": "Nom du programme à retaper",
  "v7.projets.supprimer.nom_aide": "Retapez « {{nom}} » pour confirmer.",
  "v7.projets.supprimer.nom_different": "Le nom saisi diffère du nom du programme.",
  "v7.projets.supprimer.secret": "Mot de passe (confirmation d’identité)",
  "v7.projets.supprimer.secret_aide": "Votre mot de passe confirme votre identité ; il n’est pas conservé.",
  "v7.projets.supprimer.supprimer": "Supprimer le programme",
  "v7.projets.supprimer.titre": "Supprimer le programme — confirmation",
  "v7.projets.titre": "Projets du programme",
  "v7.projets.validation.nom": "Le nom compte de 3 à 255 caractères."
}
